/* eslint-disable sonarjs/no-duplicate-string */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { AppConfig } from '../../app.config';
import { Feedback, FeedbackType, RatingType } from './feedback.model';
import { FeedbackService } from './feedback.service';
import { StorageHelper } from '../storage/storage-helper';

export interface FeedbackData {
  isBeta?: boolean;
}

@Component({
  selector: 'app-feedback-selector',
  styleUrls: ['./feedback.component.scss'],
  templateUrl: './feedback.component.html',
  standalone: false
})
export class FeedbackComponent implements OnInit {
  feedback: Feedback;
  isBeta: boolean = false;
  // Should this come from an API?
  types: FeedbackType[] = [
    {
      key: 'General Comments',
      value: 'General Comments'
    },
    {
      key: 'Data Issue',
      value: 'Report data issue on this page'
    }
  ];
  ratings: RatingType[] = [
    {
      category: 'sentiment_very_dissatisfied',
      value: 'Hate'
    },
    {
      category: 'sentiment_dissatisfied',
      value: 'Dislike'
    },
    {
      category: 'sentiment_neutral',
      value: 'Neutral'
    },
    {
      category: 'sentiment_satisfied',
      value: 'LikeIt'
    },
    {
      category: 'sentiment_very_satisfied',
      value: 'LoveIt'
    },
  ];


  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private readonly feedbackService: FeedbackService,
    private readonly router: Router,
    public dialogRef: MatDialogRef<FeedbackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FeedbackData,
  ) {
    this.isBeta = this.data.isBeta;
  }

  ngOnInit() {
    this.newModel();
  }

  onMessageChange(message: string) {
    this.feedback.message = message;
  }

  onContactChange(contact: boolean) {
    this.feedback.contact = contact;
  }

  onTypeChange(feedbackType: string) {
    this.feedback.type = feedbackType;
  }

  onRatingSelected(rating: string) {
    this.feedback.rating = rating;
  }

  cancelFeedback() {
    this.newModel();

    this.dialogRef.close();

    if (this.isBeta) {
      this.exitBeta();
    }
  }

  sendFeedback() {
    this.feedback.url = this.currentUrl()
    this.feedbackService.sendFeedback(this.feedback).subscribe(_ => {
      this.newModel();

      this.dialogRef.close();

      if (this.isBeta) {
        this.exitBeta();
      }
    });
  }

  newModel() {
    this.feedback = { message: '', contact: true, type: 'General Comments' };
  }

  showRatingOptions() {
    return this.feedback.type === 'General Comments';
  }

  showUrl() {
    return this.feedback.type === 'Data Issue';
  }

  currentUrl(): string {
    return window.location.href || this.router.url;
  }

  exitBeta() {
    const host = AppConfig.hosts.hickoryApi;

    // Exit beta
    StorageHelper.clearEmbedUxForHost(host);
    StorageHelper.saveIsBetaUx(false);

    // If we're on a Hickory page, go back to the same page
    location.href = host;
  }
}
